import React, { useRef } from 'react';
import { useSelector } from 'react-redux';
import '../../../registerSyncfusion';
import { TooltipComponent } from '@syncfusion/ej2-react-popups';
import classes from './Tooltip.module.css';
import './Tooltip.css';

const SyncfusionTooltip = ({ children, text, className, classNameTooltip, showTooltip, modeOpen, notRemoveSpecialChars, position = 'TopCenter' }) => {

    const tooltipInstanceRef = useRef();

    const { lang } = useSelector(state => state.translate);

    const removeSpecialChars = () => {
        if (!notRemoveSpecialChars)
            return text?.replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/"/g, "&quot;")
                .replace(/'/g, "&#039;");
        return text
    }

    const beforeRenderHandler = () => {
        tooltipInstanceRef.current.content = (
            `<div class=${classes.Wrap}>
                ${showTooltip && text ?
            `<div class="${classes.Tooltip} ${className}">${removeSpecialChars()}</div>`
            : ''}
            </div>`
        );
        tooltipInstanceRef.current.dataBind();
    };

    return (
        <TooltipComponent
            offsetX={position === 'LeftCenter' ? 5 : 0}
            offsetY={position === 'TopCenter' ? 5 : 0}
            position={position}
            cssClass={`Tooltip ${className} ${classes[`MyLang_${lang}`]}`}
            showTipPointer={showTooltip}
            ref={tooltipInstanceRef}
            beforeRender={beforeRenderHandler}
            opensOn={modeOpen ? `Focus ${modeOpen}` : 'Auto'}
            className={classNameTooltip}
        >
            <div className="target">
                {children}
            </div>
        </TooltipComponent>
    );
};

export default SyncfusionTooltip;
